import React, { useState } from "react";
import "./Estilos.scss";
import people from "./images/people.jpg";
const Menu = () => {
  const [number, setNumber] = useState(10);
  function topNext() {
    document.querySelector(".contenedor").scrollLeft +=
      document.querySelector(".contenedor").offsetWidth;
  }
  function topPrev() {
    document.querySelector(".contenedor").scrollLeft -=
      document.querySelector(".contenedor").offsetWidth;
  }
  function scrollNext() {
    document.querySelector(".contenedor-r").scrollLeft += "130";
  }
  function scrollPrev() {
    document.querySelector(".contenedor-r").scrollLeft -= "130";
  }

  function stop(e) {
    e.preventDefault();
  }
  return (
    <main>
      <section className="inicio-main">
        <h2>Lorem ipsum dolor sit amet.</h2>
        <p>
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sunt,
          tempore.
        </p>
        <button>Lorem ipsum dolor sit.</button>
      </section>
      <section className="main-off">
        <h2>Lorem ipsum dolor sit amet</h2>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad
          necessitatibus laudantium voluptatum, reiciendis autem quaerat.
        </p>
        <a href="/" onClick={stop}>
          hombre
        </a>
        <a href="/" onClick={stop}>
          mujer
        </a>
        <a href="/" onClick={stop}>
          ver todo
        </a>
      </section>
      <section className="main-top">
        <h2>Popular ahora</h2>
        <section className="product-top">
          <article>
            <h2>Lorem ipsum dolor sit amet</h2>
          </article>
          <article>
            <h2>Lorem ipsum dolor sit.</h2>
          </article>
          <article>
            <h2>Lorem ipsum doloring.</h2>
          </article>
          <article>
            <h2>Lorem ipsum dolor sit .</h2>
          </article>
          <article>
            <h2>Lorem ipsum dolor sit amet .</h2>
          </article>
          <article>
            <h2>Lorem ipsum dolor sit amet .</h2>
          </article>
        </section>
      </section>
      <section className="main-buy">
        <h2>¿Para quién compras?</h2>
        <section className="section-buy">
          <figure>
            <img src={people} alt="comprar" />
            <figcaption>Lorem ipsum dolor</figcaption>
          </figure>
          <figure>
            <img src={people} alt="comprar" />
            <figcaption>Lorem ipsum dolor</figcaption>
          </figure>
          <figure>
            <img src={people} alt="comprar" />
            <figcaption>Lorem ipsum dolor</figcaption>
          </figure>
        </section>
      </section>
      <section class="main-tendencia">
        <h2>
          <i class="bx bx-right-arrow-alt"></i> Novedades
        </h2>
        <button className="all">ver todo</button>
        <button onClick={topPrev} className="next-top">
          <i class="bx bx-chevron-left"></i>
        </button>
        <button className="prev-top" onClick={topNext}>
          <i class="bx bx-chevron-right"></i>
        </button>
        <div className="contenedor">
          <section className="contenedor-buy">
            <article>
              <img src={people} />
              <span>700 USD</span>
              <p className="texto">
                Lorem ipsum, dolor sit amet consectetur adipisicing.
              </p>
              <p className="name">Lorem ipsum</p>
              <p className="enviar">envío gratis</p>
            </article>
            <article>
              <img src={people} />
              <span>700 USD</span>
              <p className="texto">
                Lorem ipsum, dolor sit amet consectetur adipisicing.
              </p>
              <p className="name">Lorem ipsum</p>
              <p className="enviar">envío gratis</p>
            </article>
            <article>
              <img src={people} />
              <span>700 USD</span>
              <p className="texto">
                Lorem ipsum, dolor sit amet consectetur adipisicing.
              </p>
              <p className="name">Lorem ipsum</p>
              <p className="enviar">envío gratis</p>
            </article>
            <article>
              <img src={people} />
              <span>700 USD</span>
              <p className="texto">
                Lorem ipsum, dolor sit amet consectetur adipisicing.
              </p>
              <p className="name">Lorem ipsum</p>
              <p className="enviar">envío gratis</p>
            </article>
            <article>
              <img src={people} />
              <span>700 USD</span>
              <p className="texto">
                Lorem ipsum, dolor sit amet consectetur adipisicing.
              </p>
              <p className="name">Lorem ipsum</p>
              <p className="enviar">envío gratis</p>
            </article>
            <article>
              <img src={people} />
              <span>700 USD</span>
              <p className="texto">
                Lorem ipsum, dolor sit amet consectetur adipisicing.
              </p>
              <p className="name">Lorem ipsum</p>
              <p className="enviar">envío gratis</p>
            </article>
            <article>
              <img src={people} />
              <span>700 USD</span>
              <p className="texto">
                Lorem ipsum, dolor sit amet consectetur adipisicing.
              </p>
              <p className="name">Lorem ipsum</p>
              <p className="enviar">envío gratis</p>
            </article>
            <article>
              <img src={people} />
              <span>700 USD</span>
              <p className="texto">
                Lorem ipsum, dolor sit amet consectetur adipisicing.
              </p>
              <p className="name">Lorem ipsum</p>
              <p className="enviar">envío gratis</p>
            </article>
            <article>
              <img src={people} />
              <span>700 USD</span>
              <p className="texto">
                Lorem ipsum, dolor sit amet consectetur adipisicing.
              </p>
              <p className="name">Lorem ipsum</p>
              <p className="enviar">envío gratis</p>
            </article>
            <article>
              <img src={people} />
              <span>700 USD</span>
              <p className="texto">
                Lorem ipsum, dolor sit amet consectetur adipisicing.
              </p>
              <p className="name">Lorem ipsum</p>
              <p className="enviar">envío gratis</p>
            </article>
            <article>
              <img src={people} />
              <span>700 USD</span>
              <p className="texto">
                Lorem ipsum, dolor sit amet consectetur adipisicing.
              </p>
              <p className="name">Lorem ipsum</p>
              <p className="enviar">envío gratis</p>
            </article>
          </section>
        </div>
      </section>
      <section className="section-novedades">
        <h2>Tendencias</h2>
        <button className="next" onClick={scrollNext}>
          &#8594;
        </button>
        <div className="contenedor-r">
          <section>
            <article>
              <img src={people} alt="people" />
              <h3>Lorem ipsum dolor sit amet consectetur.</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde,
                esse. Iure!
              </p>
              <b>comprar ahora</b>
            </article>
            <article>
              <img src={people} alt="people" />
              <h3>Lorem ipsum dolor sit amet consectetur.</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde,
                esse. Iure!
              </p>
              <b>comprar ahora</b>
            </article>
            <article>
              <img src={people} alt="people" />
              <h3>Lorem ipsum dolor sit amet consectetur.</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde,
                esse. Iure!
              </p>
              <b>comprar ahora</b>
            </article>
            <article>
              <img src={people} alt="people" />
              <h3>Lorem ipsum dolor sit amet consectetur.</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde,
                esse. Iure!
              </p>
              <b>comprar ahora</b>
            </article>
            <article>
              <img src={people} alt="people" />
              <h3>Lorem ipsum dolor sit amet consectetur.</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde,
                esse. Iure!
              </p>
              <b>comprar ahora</b>
            </article>
            <article>
              <img src={people} alt="people" />
              <h3>Lorem ipsum dolor sit amet consectetur.</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde,
                esse. Iure!
              </p>
              <b>comprar ahora</b>
            </article>
          </section>
        </div>
        <button className="prev" onClick={scrollPrev}>
          &#8592;
        </button>
      </section>
      <section className="section-article">
        <h2>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Debitis,
          provident.adipisicing elit. Debitis, provident.
        </h2>
        <button>conoce más &#8594; </button>
      </section>
      <section className="section-about">
        <section>
          <article>
            <h2>Lorem ipsum dolor sit amet consectetur.</h2>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Veniam
              eius delectus iusto, recusandae doloribus consequuntur voluptatem?
              Consectetur, quos ad nostrum sequi consequuntur minus unde
              repellat expedita rerum incidunt suscipit tenetur earum esse,
              perferendis culpa. Pariatur nisi quaerat tenetur reprehenderit
              aspernatur similique, dolor odit quis dolores impedit quae omnis
              sunt repudiandae. Maxime fugiat amet sunt nobis dolore alias
              quisquam sequi repellat maiores? Vel soluta distinctio ut,
              suscipit quos eveniet ullam ex?
            </p>
          </article>
          <article>
            <h2>Lorem ipsum dolor sit amet consectetur.</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil
              quia, quas a et voluptatem voluptatibus! Harum quod reprehenderit
              architecto laborum dignissimos velit vitae suscipit doloremque
              commodi quisquam, eligendi beatae nam voluptatum, molestias quis
              voluptatibus! Mollitia, pariatur! Quisquam aperiam impedit vero,
              ipsam dolor vel velit. Placeat, iste omnis? Quae laborum
              cupiditate distinctio possimus accusantium repellendus temporibus
              porro dolores earum eos odio facilis, facere sunt numquam
              voluptatum labore voluptatem doloribus? Natus, voluptas fugit
              alias quasi est illo ab culpa delectus necessitatibus odio
              officiis dolorem, dolorum modi totam corrupti perspiciatis
              commodi? Ea, harum?
            </p>
          </article>
        </section>
      </section>
      <section className="section-login">
        <div>
          <h2>Únete al club y consigue un 15 % de descuento</h2>
          <button>regístrate gratis &#8594;</button>
        </div>
      </section>
      <section className="section-contacto">
        <section>
          <aside>
            <h2>productos</h2>
            <p>Calzado</p>
            <p>Zapatilla</p>
            <p>Ropa</p>
            <p>Accesorios</p>
            <p>Chimpunes</p>
            <p>Cortavientos</p>
            <p>Buzos</p>
            <br />
            <p>Novedades</p>
            <p>Cyver Wow</p>
            <p>Cyber Monday</p>
            <p>Cyber Days</p>
            <p>Black Friday</p>
            <p>Outlet</p>
          </aside>
          <aside>
            <h2>deportes</h2>
            <p>Sporting Cristal</p>
            <p>Fútbol</p>
            <p>Running</p>
            <p>Básquet</p>
            <p>Training</p>
            <h2>colecciones</h2>
            <p>Poleras</p>
            <p>Casacas</p>
            <p>Polos</p>
            <p>Original</p>
            <p>Gorras</p>
            <p>Zapatillas</p>
          </aside>
          <aside>
            <h2>asistencia</h2>
            <p>¿Necesitas ayuda?</p>
            <p>Servicio al cliente</p>
            <p>Dudas frecuentes</p>
            <p>Realizar pedidos</p>
            <p>Productos</p>
            <p>Pago</p>
            <p>Envío</p>
            <p>Solicitar mi devolución</p>
            <p>Devoluciones</p>
            <p>Cambio en tiendas</p>
            <p>Como usar nuestro sitio</p>
            <p>Guia de tallas</p>
            <p>Mapa del sitio</p>
          </aside>
          <aside>
            <h2>información de la empresa</h2>
            <p>Acerca de nosotros</p>
            <p>Trabaja en nuestro equipo</p>
            <p>Prensa</p>
            <h2>tiendas</h2>
            <p>Buscador de tiendas</p>
          </aside>
          <aside>
            <h2>síguenos</h2>
            <a href="/" onClick={stop}>
              <i class="bx bxl-facebook-circle"></i>
            </a>
            <a href="/" onClick={stop}>
              <i class="bx bxl-instagram"></i>
            </a>
            <a href="/" onClick={stop}>
              <i class="bx bxl-twitter"></i>
            </a>
            <a href="/" onClick={stop}>
              <i class="bx bxl-pinterest"></i>
            </a>
            <a href="/" onClick={stop}>
              <i class="bx bxl-tiktok"></i>
            </a>
            <a href="/" onClick={stop}>
              <i class="bx bxl-youtube"></i>
            </a>
          </aside>
        </section>
      </section>
    </main>
  );
};

export default Menu;
